import { BaseErrorLayout } from '@dvb/ui';
import { Button } from '@heroui/react';
import { useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

/**
 * Navigate to setting instead of home is because setting do not involve any data fetching,
 * it should be the most stable page.
 */
export function DefaultError() {
  const { t } = useTranslation('ui');
  const navigate = useNavigate();

  return (
    <BaseErrorLayout
      actionElement={
        <Button onPress={() => navigate({ to: '/setting' })}>
          {t('setting')}
        </Button>
      }
      className="bg-background w-full"
    />
  );
}
